"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
var GraphQLErrorFunctions_1 = require("../../error/functions/GraphQLErrorFunctions");
var makeColumnFactoryParams_1 = require("../../sorting/makeColumnFactoryParams");
var SiteUrlsContext_1 = require("../../urls/SiteUrlsContext");
var VizPortalTypes_1 = require("../../utils/VizPortalTypes");
var CertificationWidget_1 = require("../Certification/CertificationWidget");
var CountBarCellFormatter_1 = require("../datagrid/cellFormatters/CountBarCellFormatter");
var DatabaseNameCell_1 = require("../datagrid/cellFormatters/DatabaseNameCell");
var IconCellFormatter_1 = require("../datagrid/cellFormatters/IconCellFormatter");
var ObfuscatedCellFormatter_1 = require("../datagrid/cellFormatters/ObfuscatedCellFormatter");
var QualityCellFormatter_1 = require("../datagrid/cellFormatters/QualityCellFormatter");
var UserNameCell_1 = require("../datagrid/cellFormatters/UserNameCell");
var ColumnFactory_1 = require("../datagrid/ColumnFactory");
var DataQualityIconHeaderFormatFactory_1 = require("../datagrid/headerFormatters/DataQualityIconHeaderFormatFactory");
var SortableHeaderFormatter_1 = require("../datagrid/headerFormatters/SortableHeaderFormatter");
var TypedDataGridInterfaces_1 = require("../datagrid/TypedDataGridInterfaces");
var TableIcon_1 = require("../icons/TableIcon");
var ExplorerStyledDisplayGrid_1 = require("./ExplorerStyledDisplayGrid");
var shouldBeObfuscated = function (_a) {
    var name = _a.name;
    return name === null;
};
function iconColumn(rowData) {
    if (rowData.__typename === 'DatabaseTable' && rowData.isCertified) {
        return (React.createElement(SiteUrlsContext_1.SiteUrlsContext.Consumer, null, function (urls) {
            return React.createElement(CertificationWidget_1.CertificationWidget, { icon: React.createElement(TableIcon_1.TableMediumIcon, { isCertified: rowData.isCertified }), contentId: rowData.id, certification: rowData, siteUrls: urls, showExtractRefresh: false });
        }));
    }
    return React.createElement(TableIcon_1.TableMediumIcon, { isCertified: false });
}
exports.columns = [
    function () { return ({
        name: 'warning',
        dataKey: '',
        headerText: '',
        headerTooltip: Localize_1.Messages.DataQualityWarningTitle(),
        headerFormatter: DataQualityIconHeaderFormatFactory_1.DataQualityIconHeaderFormatterFactory,
        cellFormatter: QualityCellFormatter_1.createDataQualityCellFormatter(function (r) { return (r.__typename !== 'DatabaseTable' || !r.dataQualityWarning) ? undefined : __assign({ kind: 'fragment' }, r.dataQualityWarning); }),
        sortable: false,
        resizable: false
    }); },
    function (sortParams) { return ({
        name: 'type',
        dataKey: globalTypes_1.TableOrderField.IS_CERTIFIED,
        headerText: Localize_1.Messages.GridHeaderType(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: IconCellFormatter_1.createIconCellFormatter(function (rowData) { return iconColumn(rowData); }, function (rowData) { return (rowData.__typename === 'DatabaseTable' && rowData.isCertified) ? '' : Localize_1.Messages.Table(); }),
        resizable: false,
        sortable: true,
    }); },
    function (params) { return params.actionCellWrapper({
        name: 'name',
        dataKey: globalTypes_1.TableOrderField.NAME,
        headerText: Localize_1.Messages.GridHeaderName(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(params),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedLinkCellFormatter(shouldBeObfuscated, function (_a) {
            var name = _a.name;
            return name;
        }, function (urls, _a) {
            var id = _a.id;
            return urls.catalogTablePath(id);
        }),
        growToFit: true,
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'workbooks',
        dataKey: globalTypes_1.TableOrderField.DOWNSTREAM_WORKBOOKS_COUNT,
        headerText: Localize_1.Messages.GridHeaderWorkbooks(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: CountBarCellFormatter_1.createCountBarCellFormatter(function (_a) {
            var downstreamWorkbooksConnection = _a.downstreamWorkbooksConnection;
            return downstreamWorkbooksConnection ? downstreamWorkbooksConnection.totalCount : null;
        }, function (_a) {
            var maxDownstreamWorkbooks = _a.maxDownstreamWorkbooks;
            return maxDownstreamWorkbooks ? maxDownstreamWorkbooks : null;
        }),
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'datasources',
        dataKey: globalTypes_1.TableOrderField.DOWNSTREAM_DATASOURCES_COUNT,
        headerText: Localize_1.Messages.GridHeaderDatasources(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: CountBarCellFormatter_1.createCountBarCellFormatter(function (_a) {
            var downstreamDatasourcesConnection = _a.downstreamDatasourcesConnection;
            return downstreamDatasourcesConnection ? downstreamDatasourcesConnection.totalCount : null;
        }, function (_a) {
            var maxDownstreamDatasources = _a.maxDownstreamDatasources;
            return maxDownstreamDatasources ? maxDownstreamDatasources : null;
        }),
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'database',
        dataKey: '',
        headerText: Localize_1.Messages.GridHeaderDatabaseNamePath(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedTextCellFormatter(shouldBeObfuscated, DatabaseNameCell_1.getDatabaseDisplayString),
        resizable: true,
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'columns',
        dataKey: TypedDataGridInterfaces_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderColumns(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedNamesWithCountCellFormatter(shouldBeObfuscated, function (_a) {
            var columnsConnection = _a.columnsConnection;
            return columnsConnection ? columnsConnection.nodes.map(function (column) { return column.name || ''; }) : [];
        }, function (_a) {
            var columnsConnection = _a.columnsConnection;
            return columnsConnection ? columnsConnection.totalCount : 0;
        }),
        resizable: true,
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'contact',
        dataKey: TypedDataGridInterfaces_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderContact(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: UserNameCell_1.createUserNameLinkCellFormatter(function (rowData) { return rowData.__typename === 'DatabaseTable' ? rowData.contact : null; }),
        resizable: true,
        sortable: false,
    }); }
];
exports.columnsForVizPortal = ColumnFactory_1.mapDC3ColumnFactoriesToVizPortalColumnFactories(exports.columns, makeColumnFactoryParams_1.makeDC3ColumnFactoryParamsFromVizPortalParams);
function TablesDisplayGrid(props) {
    var columnFactoryParams = VizPortalTypes_1.addNoopActionCellWrapper(props);
    var cols = exports.columns.map(function (columnFactory) { return columnFactory(columnFactoryParams); });
    return (React.createElement(ExplorerStyledDisplayGrid_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, emptyGridMessage: props.emptyGridMessage, rowCount: props.rowCount, renderErrors: GraphQLErrorFunctions_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.TablesDisplayGrid = TablesDisplayGrid;
//# sourceMappingURL=TablesDisplayGrid.js.map